






























import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component
export default class TagSheet extends Vue {
    @Prop({type: String, default: '#DE4077'}) actionColor!: string
    @Prop({type: Boolean, default: false}) multiSelect!: boolean
    @Prop({type: Array, default() { return []}}) options!: Array<{label: string, value: any}>
    @Prop({type: Array, default() { return []}}) value!: any[]

    hover = null

    @Watch('multiSelect')
    watchMultiSelect(): void {
        if (!this.multiSelect) {
            this.$emit('tag-sheet-clear-value', [])
        }
    }

    emitSelected(value: any): void {
        if (!this.multiSelect) {
            this.$emit('input', [])
            return
        }

        if (this.value.includes(value)) {
            this.value.splice(this.value.indexOf(value), 1)
        } else {
            this.value.push(value)
        }

        this.$emit('input', this.value)
    }
}
